import React from 'react';
import PropTypes from 'prop-types';

import styled from 'styled-components';

import { NitroIcon } from 'nitro-components';

import StepIndicator from './components/StepIndicator';
import NavBar from './NavBar';

const NewReportContainer = styled.div`
  overflow: auto;
  display: ${props => (props.isOpen ? 'block' : 'none')};
  position: fixed;
  z-index: 100;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #f0f0f0;
`;

const CloseButton = styled.button`
  position: absolute;
  right: 20px;
  top: 20px;

  border: 0;
  outline: none;
  background: none;
`;

const Header = styled.div`
  height: 60px;
  background-color: ${props => props.theme.color.primary};
  font-family: ${props => props.theme.font.bold};
  font-size: ${props => props.theme.size[2]};
  color: ${props => props.theme.color.white};

  display: flex;
  align-items: center;
  justify-content: center;
`;

const Content = styled.section`
  position: absolute;
  top: 120px;
  bottom: 70px;
  width: 100%;
  overflow: auto;
`;

const NewReportLayout = ({ children, title = 'Create my report', isOpen, close, steps, navigation, navigationComponent }) => {
  const { currentStep, visitedStep, goToStep } = navigation;
  return (
    <NewReportContainer isOpen={isOpen}>
      <Header>
        {title}
        <CloseButton onClick={close}>
          <NitroIcon size={16} name="close" variant="white" />
        </CloseButton>
      </Header>
      <StepIndicator steps={steps} goToStep={goToStep} currentStep={currentStep} visitedStep={visitedStep} />
      <Content>
        {children}
      </Content>
      <NavBar navigation={navigation} navigationComponent={navigationComponent} />
    </NewReportContainer>
  );
};

export default NewReportLayout;

NewReportLayout.propTypes = {};



// WEBPACK FOOTER //
// ./src/features/scheduling-reports/new-report/NewReportLayout.js